import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../components/tables/simpleTable';

import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddModal from '../../components/modals/addModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';
import CartModal from '../../components/modals/cartModal';

import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import IsOrderFilter from '../../components/filters/isOrderFilter';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';


import { FcKindle } from "react-icons/fc";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter, decimalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../components/formatters/defFormatter';
import { clientOrderColumnDefs } from '../../components/tables/columnDefs';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs } from 'antd';
import AsyncDropDownFilter from '../../components/filters/asyncDropdownFilter';
import Select from 'react-select';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';
import e from 'cors';




function LowInStock(props) {
  let { type } = props;

  const { api, userData, settingData, wareHouseData, refWareHouseData, categoryData, deliveryData } = useContext(DataContext);
  const createdBy = parseInt(userData.id);
  const roundTo = settingData.roundTo;
  const userRole = userData.role;
  const defaultWareHouseId = userData.role.wareHouseSaleId;

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const table = 'stockValue';
  const title = 'Stock Value';

  const [idRow, setIdRow] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ 
    search: '', 
    isActive: 'true', 
    type: ['simple', 'serialized'], 
    wareHouseId: defaultWareHouseId, 
    isLowInStock: false, 
    categoryId: null,
    customLowStockValue: null,
    productId: null
  });

  const [showCartModal, setShowCartModal] = useState(false);  
  const [transaction, setTransaction] = useState(false);
  const [customLowStockInput, setCustomLowStockInput] = useState(''); // For user input
  const [loadingCounter, setLoadingCounter] = useState(0);

  // Get Data 
  useEffect(() => {
    const fetchData = async () => {
      try {
        await refWareHouseData();
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);

  const categoryOptions = categoryData.map(item => ({
    value: item.id,
    label: item.name,
  }));
  categoryOptions.push({ value: null, label: 'All Categories' });

  // WareHouse Options
  const wareHouseOptions = wareHouseData?.map(item => ({
    value: item.id,
    label: item.name,
  }));

  const selectedWareHouse = wareHouseOptions.filter(option => option.value === filter.wareHouseId);

  // Handle custom low stock filter
  const handleCustomLowStockFilter = () => {
    const value = parseFloat(customLowStockInput);
    if (!isNaN(value) && value >= 0) {
      setFilter(prev => ({
        ...prev,
        customLowStockValue: value,
        isLowInStock: false // Disable default low stock filter when using custom
      }));
    } else {
      toast.error("Please enter a valid number");
    }
  };

  // Reset to default low stock filter
  const resetToDefaultLowStock = () => {
    setCustomLowStockInput('');
    setFilter(prev => ({
      ...prev,
      customLowStockValue: null,
      isLowInStock: false // Enable default low stock filter
    }));
  };

  const reStock = async () => {
    try {
      setIsLoading(true);
      const data = {
        wareHouseId: filter.wareHouseId,
      }
      let res = await api.post(`stockValue/reStockWareHouse`, data);

      if (res.data.status) {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }
      setIsLoading(false);
    } catch (error) {
      toast.error("Failed Contact Support");
      setIsLoading(false);
    }
  }

  // Excel Data (unchanged)
  const getExcelData = (data, getSummary) => {
    const transformedData = [];
    data.forEach(item => {
      const newItem = {
        id: item.id,
        barcode: item.barcode,
        category: item.category?.name,
        name: item.name,
        totalStock: item.totalStock,
        cost: item.cost,
        price: item.price,
        type: item.type,
      };
      transformedData.push(newItem);
    });
    
    const summary = {
      Quantity: getSummary.totalProducts,
      LowInStock: getSummary.totalLowInStock,
      StockValue: getSummary.stockCost,
      ExpectedProfit: getSummary.totalExpectedProfit,
    }

    return { transformedData, summary };
  };

  let newColumnDefs = [
    { title: 'ID', dataIndex: 'id', width: '6%', sorter: (a, b) => a.age - b.age },
    { title: 'Barcode', dataIndex: 'barcode' },
    { title: 'Category', dataIndex: 'category', render: (category) => (category?.name) },
    { title: 'Name', dataIndex: 'name' },
    { title: 'Stock', dataIndex: 'totalStock', render: (totalStock, record) => (numberFormatter(totalStock, 2) + ' ' + record.unit) },
    { title: 'Price', dataIndex: 'price', width: '8%', render: numberFormatter },
    { title: 'Type', dataIndex: 'type' },
  ];

  useEffect(() => {
    setColumnDefs(newColumnDefs);
  }, [filter.isActive]);

  const formView = '';

  const tableFooter = (
    <div style={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', left: '35%', transform: 'translateX(-50%)' }}>
      <div>
        <span className='table-footer footer-yellow'>Quantity: {numberFormatter(data?.summary?.totalProducts, 2)}</span>
        <span className='table-footer footer-red'>Low In Stock: {numberFormatter(data?.summary?.totalLowInStock, 2)} </span>
      </div>
    </div>
  );

  return (
    <div className='card'>
      {isLoading && <Loader />}

      {!isLoading &&
        <>
          <div>
            <SearchFilter setFilter={setFilter} />

            <DataFilter selectedOption={selectedWareHouse} setFilter={setFilter} dataOptions={wareHouseOptions} filterBy={'wareHouseId'} placeHolder={'All WareHouse'} />

            <DataFilter setFilter={setFilter} dataOptions={categoryOptions} 
              filterBy={'categoryId'} placeHolder={'All Categories'} />

             <AsyncDropDownFilter
              setFilter={setFilter}
              filterBy={'productId'}
              placeHolder={'All Product'}
              filter={filter}
              isClearable={true}
              setLoadingCounter={() => setLoadingCounter((prevCounter) => prevCounter + 1)}
            />

            {/* Custom Low Stock Filter */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '15px' }}>
              <Form.Control 
                type="number"
                placeholder="low stock value"
                value={customLowStockInput}
                onChange={(e) => setCustomLowStockInput(e.target.value)}
                style={{ width: '200px' }}
                min="0"
                step="1"
              />
              <CustomButton 
                tittle={'Low In Stock'} 
                method={handleCustomLowStockFilter} 
                color={'#2b7b76'}
              />
              {filter.customLowStockValue !== null && (
                <CustomButton 
                  tittle={'Reset to Default'} 
                  method={resetToDefaultLowStock} 
                  color={'#6c757d'}
                />
              )}
            </div>

           
          </div>

          <SimpleTable
            filter={filter}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
          />
        </>
      }
    </div>
  )
}

export default LowInStock;
